// handle form submission error
addEventListener("ajax:error", event => {
  alert("An error occurred! Please check your network, refresh your page and try again.")
})
